import { ReactElement } from "react";
import classNames from "classnames";
import { useMainMenuStore } from "../Layout/mainMenuStore";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import styles from "./AiAssistantFabSpacing.module.less";

export type AiAssistantFabSpacingProps = {
	shouldIncludeContentPadding?: boolean;
};

export const AiAssistantFabSpacing = (props: AiAssistantFabSpacingProps): ReactElement | null => {
	const {
		shouldIncludeContentPadding = false
	} = props;

	const isAiAssistantAvailable: boolean = useMainMenuStore(x => x.isAiAssistantAvailable);
	const isResponsive: boolean = useWorkspaceMediaQuery(MediaQueryKind.Responsive);

	const shouldReserveSpace: boolean = isAiAssistantAvailable
		&& !isResponsive;

	if (!shouldReserveSpace) {
		return null;
	}

	return (
		<div
			className={classNames(
				styles.root,
				{ [styles.root_assumeNoContentPadding]: shouldIncludeContentPadding }
			)}
		/>
	);
};
AiAssistantFabSpacing.displayName = "AiAssistantFabSpacing";
